export default "__VITE_ASSET__3bc58bac__"